import React, { useState, useEffect, useRef, useCallback } from 'react'
import { func, shape, string } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import {
  clearTicketNumbers,
  // preloadChaseTransaction,
  // getChaseTransactionReceipt,
  clearReceipts,
  postBooking,
  postTelephoneBooking,
  clearCaptchaToken,
  getCaptchaToken
  // getTransactionReceipt
} from '../../redux/booking/actions'
// import {
//   // selectPreloadingTransaction,
//   // selectPreloadTransactionSuccess,
//   // selectPreloadTransactionError,
//   // selectPreloadedTicketNumbers,
//   selectGetReceiptError,
//   selectGetReceiptSuccess,
//   selectReceipts,
//   // selectCaptchaToken
// } from '../../redux/booking/selectors'
import { PAYMENT_METHOD_INVOICE } from './constants'
// hard coded labels temporarily as fallback values
import HARD_CODE_LABELS from '../../configuration/labels'
// import { preparePreloadChaseData } from './utilities'
import { selectActiveModifyBooking } from '../../redux/modifyBooking/selectors'
// import {
//   CHECKOUT_SUCCESS_CODE_CHASE,
//   CHECKOUT_SUCESSS_STATUS_CHASE
// } from '../MonerisCheckout/constants'
import { appRoutes } from '../../configuration/constants'
import { validateRoute } from '../../redux/selectors/utils'
import modalIds from '../../context/configuration'
import BrandLoader from '../BrandLoader/BrandLoader'
import { buildModifyPassengers } from '../../redux/booking/utilities'
import { selectDuplicatePassengerQuantities } from '../../redux/passengerSelections/selectors'
import { selectFields } from '../../redux/configuration/selectors'
import { selectPassengersForBooking } from '../../redux/selectors/selectPassengersForBooking'
import { selectPaymentFerryId } from '../../redux/paymentConfirmation/selectors'
import { selectTravelAgentBookingParams } from '../../redux/travelAgent/selectors'
import { selectUserSelections } from '../../redux/userSelections/selectors'
import { SET_BOOKING_SUCCESS } from '../../redux/booking/constants'
import { selectCurrency } from '../../redux/session/selectors'

// const useHpfCallbacks = ({
//   onready,
//   onStart,
//   onCancel,
//   onErrors,
//   onComplete
// }) => {
//   useEffect(() => {
//     window.hpfReady = () => onready?.()
//     window.startPayment = () => onStart?.()
//     window.cancelPayment = res => onCancel?.(res)
//     window.handlePaymentErrors = err => onErrors?.(err)
//     window.completePayment = res => onComplete?.(res)
//     window.scrollRelay = () => {}

//     return () => {
//       try {
//         delete window.hpfReady
//       } catch {}
//       try {
//         delete window.startPayment
//       } catch {}
//       try {
//         delete window.cancelPayment
//       } catch {}
//       try {
//         delete window.handlePaymentErrors
//       } catch {}
//       try {
//         delete window.completePayment
//       } catch {}
//       try {
//         delete window.scrollRelay
//       } catch {}
//     }
//   }, [onready, onStart, onCancel, onErrors, onComplete])
// }

const ChaseCheckoutContainer = ({
  bookingConfirmationData,
  ferryId,
  labels,
  lang,
  isTelephoneBooking,
  cancelTransactionRouteTarget,
  handleRouteChange,
  openModal
}) => {
  const dispatch = useDispatch()

  // const preloadingTransaction = useSelector(selectPreloadingTransaction)
  // const preloadTransactionError = useSelector(selectPreloadTransactionError)
  // const preloadTransactionSuccess = useSelector(selectPreloadTransactionSuccess)
  // const preloadedTickets = useSelector(selectPreloadedTicketNumbers)
  // const getReceiptError = useSelector(selectGetReceiptError)
  // const getReceiptSuccess = useSelector(selectGetReceiptSuccess)
  const activeModifyBooking = useSelector(selectActiveModifyBooking)
  const currencyType = useSelector(selectCurrency)
  const duplicatePassengerQuantities = useSelector(
    selectDuplicatePassengerQuantities
  )
  const fields = useSelector(selectFields)
  const passengerFieldDetails = useSelector(selectPassengersForBooking)
  const paymentFerryId = useSelector(selectPaymentFerryId)
  const travelAgentBookingParams = useSelector(selectTravelAgentBookingParams)
  const userSelections = useSelector(selectUserSelections)
  let telephonePassengerFieldDetails
  if (!passengerFieldDetails?.departures?.[0]?.passengers?.length) {
    telephonePassengerFieldDetails = {
      departures: (bookingConfirmationData?.departures ?? []).map(dep => ({
        passengers: (dep?.passengers?.booked ?? []).map(passenger => ({
          passengerType: passenger.passengerType
        }))
      }))
    }
  }

  // const getCaptchaToken = useSelector(selectCaptchaToken)
  // const receipts = useSelector(selectReceipts)
  // const receipt = receipts && Object.values(receipts)?.[0]

  // const [pageData, setPageData] = useState(null)
  // const [bookingPreloaded, setBookingPreloaded] = useState(false)
  // const [preloadError, setPreloadError] = useState(false)
  // const [awaitingPreload, setAwaitingPreload] = useState(true)
  // const [showHPF, setShowHPF] = useState(false)
  // const [hpfReady, setHpfReady] = useState(false)
  // const [paymentError, setPaymentError] = useState(null)
  const [submittingForm, setSubmittingForm] = useState(false)
  const [submitFormError, setSubmitFormError] = useState(false)
  const [maiPayReady, setMaiPayReady] = useState(false)
  const [captchaError, setCaptchaError] = useState(false)
  const maiPayRef = useRef(null)
  // const iframeRef = useRef(null)
  const summaryRouteCheck = useSelector(state =>
    validateRoute(appRoutes.summary.pathname, state)
  )

  const executeRecaptchaCheck = useCallback(async () => {
    return new Promise((resolve, reject) => {
      if (typeof window.grecaptcha === 'undefined') {
        return
      }

      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(
            process.env.REACT_APP_CAPTCHA_SITE_KEY,
            { action: 'submit' }
          )
          resolve(token)
        } catch (error) {
          setCaptchaError(true)
          reject(error)
        }
      })
    })
  }, [])

  // Note: Preload success reducer replaces all previous uids with 1 new uid
  // const uid = preloadedTickets?.uid

  // useEffect(() => {
  //   if (!pageData?.preloadParams) {
  //     setPageData(
  //       preparePreloadChaseData({
  //         ferryId,
  //         bookingConfirmationData,
  //         lang,
  //         labels,
  //         isTelephoneBooking,
  //         activeModifyBooking
  //       })
  //     )
  //   }
  // }, [
  //   ferryId,
  //   bookingConfirmationData,
  //   lang,
  //   labels,
  //   isTelephoneBooking,
  //   pageData,
  //   activeModifyBooking
  // ])

  const isInvoicePayment =
    bookingConfirmationData.paymentMethod === PAYMENT_METHOD_INVOICE

  // check preload state
  // useEffect(() => {
  //   if (preloadError || preloadingTransaction || awaitingPreload) return

  //   if (preloadTransactionError && !preloadTransactionSuccess) {
  //     setPreloadError(true)
  //   }
  // }, [
  //   preloadError,
  //   preloadingTransaction,
  //   preloadTransactionError,
  //   preloadTransactionSuccess,
  //   awaitingPreload
  // ])

  // preload transaction data including ticket number, order
  // useEffect(() => {
  //   if (isInvoicePayment) return

  //   if (
  //     !preloadError &&
  //     // !preloadingTransaction &&
  //     // !preloadTransactionSuccess &&
  //     pageData &&
  //     !bookingPreloaded
  //   ) {
  //     if (pageData?.preloadParams) {
  //       setAwaitingPreload(false)
  //       dispatch(
  //         preloadChaseTransaction(
  //           { ...pageData.preloadParams },
  //           bookingConfirmationData.bookingNumber,
  //           getCaptchaToken
  //         )
  //       )
  //     } else {
  //       setPreloadError(true)
  //     }
  //   }
  // }, [
  //   isInvoicePayment,
  //   preloadError,
  //   // preloadingTransaction,
  //   // preloadTransactionSuccess,
  //   pageData,
  //   dispatch,
  //   bookingPreloaded,
  //   bookingConfirmationData.bookingNumber,
  //   ferryId,
  //   getCaptchaToken
  // ])

  // const chaseLang = lang === 'fr' ? 'fr_CA' : 'en_US'
  // const hpfUrl = useMemo(() => {
  //   if (!uid) return ''
  //   return `${process.env.REACT_APP_CHASE_HOST}/hpf/?uid=${uid}&lang=${chaseLang}`
  // }, [uid, chaseLang])

  // useHpfCallbacks({
  //   onready: () => {
  //     setHpfReady(true)
  //   },
  //   onStart: () => {
  //     setPaymentError(null)
  //   },
  //   onCancel: res => {
  //     if (res?.reason_code) {
  //       openModal({ type: 'cancel-transaction' })
  //       dispatch(clearTicketNumbers())
  //       handleRouteChange(cancelTransactionRouteTarget)
  //     }
  //   },
  //   onErrors: err => {
  //     setPaymentError(err?.[0]?.status_message)
  //   },
  //   onComplete: res => {
  //     if (
  //       res?.status === CHECKOUT_SUCESSS_STATUS_CHASE &&
  //       res?.status_code === CHECKOUT_SUCCESS_CODE_CHASE &&
  //       res?.uid === uid
  //     ) {
  //       dispatch(
  //         getChaseTransactionReceipt({
  //           uid: uid
  //         })
  //       )
  //     } else {
  //       setPaymentError(labels.paymentConfirmationError)
  //     }
  //   }
  // })

  // useEffect(() => {
  //   if (preloadTransactionSuccess && uid) {
  //     setShowHPF(true)
  //   }
  // }, [preloadTransactionSuccess, uid]) // eslint-disable-line react-hooks/exhaustive-deps

  // check if mai-pay component ready
  useEffect(() => {
    let cancelled = false
    let timeoutId
    const timeout = new Promise((_, reject) => {
      timeoutId = setTimeout(() => reject(new Error('timeout')), 20000)
    })
    Promise.race([window.customElements.whenDefined('mai-pay'), timeout])
      .then(() => {
        if (cancelled) return
        setMaiPayReady(true)
      })
      .catch(() => {
        if (cancelled) return
        setSubmitFormError(true)
      })
    return () => {
      cancelled = true
      clearTimeout(timeoutId)
    }
  }, [])

  // useEffect(() => {
  //   if (getReceiptError) {
  //     if (summaryRouteCheck.routeIsValid) {
  //       handleRouteChange(appRoutes.summary.pathname)
  //     }
  //     // popup message modal
  //     openModal({
  //       type:
  //         cancelTransactionRouteTarget === appRoutes.account.pathname
  //           ? modalIds.userBookingCustomErrorModal
  //           : 'payment-error'
  //     })
  //     //clear receipt error immediately, otherwise cause dead loop!!!
  //     dispatch(clearReceipts())
  //     // clear ticket for its obsolete
  //     dispatch(clearTicketNumbers())
  //   }
  // })

  // useEffect(() => {
  //   if (getReceiptSuccess && receipt) {
  //     handleRouteChange(appRoutes.bookingConfirmation.pathname)
  //   }
  // }, [getReceiptSuccess, receipt, handleRouteChange])

  useEffect(() => {
    if (!maiPayReady) return
    const element = maiPayRef.current
    const handleMaiPayEvent = event => {
      const { type, ...data } = event.detail

      switch (type) {
        case 'submit':
          // form submission started
          setSubmitFormError(false)
          setSubmittingForm(true)
          break
        case 'success':
          // encryption succeeded
          if (data && data.encryptedCard && data.encryptedCvv && data.expiry) {
            const cardParams = {
              encryptedCvv: data.encryptedCvv,
              cvv: data.cvv,
              paymentProvider: 'Chase',
              ccAccountNum: data.encryptedCard,
              ccExp: data.expiry.replace('/', ''),
              cardBrand: data.cardType,
              pieIntegrityCheck: data.integrityCheck,
              pieKeyID: data.keyId,
              currencyType,
              customerRefNum: bookingConfirmationData?.customerNumber ?? '',
              isPhonePayment: isTelephoneBooking ? 'true' : 'false',
              pieFormatID: data?.formatId ?? data?.pieFormatID
            }
            if (!isTelephoneBooking) {
              dispatch(
                postBooking({
                  bookingInformation: userSelections.bookingInformation,
                  commitChanges: true,
                  cardParams,
                  activeModifyBooking,
                  modificationId: activeModifyBooking?.bookingNumber,
                  modifyPassengers: activeModifyBooking?.bookingNumber
                    ? buildModifyPassengers({
                        activeModifyBooking,
                        duplicatePassengerQuantities,
                        fields,
                        passengerFieldDetails,
                        passengerFormData: userSelections.passengerDetails,
                        paymentFerryId
                      })
                    : false,
                  additionalParams: travelAgentBookingParams
                })
              ).then(res => {
                if (
                  res?.type === SET_BOOKING_SUCCESS &&
                  res?.payload?.bookingNumber &&
                  !res?.payload?.warnings?.length
                ) {
                  setSubmittingForm(false)
                  handleRouteChange(
                    appRoutes.bookingConfirmation.pathname,
                    { paymentSuccess: true },
                    true
                  )
                } else {
                  if (summaryRouteCheck.routeIsValid) {
                    if (res?.payload?.bookingNumber) {
                      const params = {
                        bookingNumber: res?.payload?.bookingNumber,
                        isPhonePayment: 'false',
                        isEncryptedPayment: 'true',
                        currencyType:
                          res?.payload?.currency ??
                          bookingConfirmationData?.bookingCurrency,
                        orderId:
                          res?.payload?.orderId ??
                          bookingConfirmationData?.orderId,
                        amount:
                          res?.payload?.amountOwing ??
                          bookingConfirmationData?.amountOwing,
                        ferryId:
                          res?.payload?.ferryId ??
                          bookingConfirmationData?.ferryId,
                        paymentProvider: 'Chase',
                        customerRefNum: cardParams.customerRefNum,
                        cvv: cardParams.cvv,
                        ccAccountNum: cardParams.ccAccountNum,
                        ccExp: cardParams.ccExp,
                        cardBrand: cardParams.cardBrand,
                        bookingSource: 'Online',
                        pieFormatID: cardParams.pieFormatID
                      }
                      handleRouteChange(
                        appRoutes.summary.pathname,
                        { retryPayment: { ...params } },
                        true
                      )
                    } else {
                      handleRouteChange(appRoutes.summary.pathname, null, true)
                    }
                  }
                  // popup message modal
                  openModal({
                    type:
                      cancelTransactionRouteTarget ===
                      appRoutes.account.pathname
                        ? modalIds.userBookingCustomErrorModal
                        : 'payment-error'
                  })
                  //clear receipt error immediately, otherwise cause dead loop!!!
                  dispatch(clearReceipts())
                  // clear ticket for its obsolete
                  dispatch(clearTicketNumbers())
                }
              })
            } else {
              dispatch(
                postTelephoneBooking({
                  bookingInformation: bookingConfirmationData,
                  cardParams,
                  isTelePhonePayment: isTelephoneBooking ? 'true' : 'false'
                })
              ).then(res => {
                if (res?.type === SET_BOOKING_SUCCESS) {
                  setSubmittingForm(false)
                  handleRouteChange(
                    appRoutes.bookingConfirmation.pathname,
                    { paymentSuccess: true },
                    true
                  )
                } else {
                  // popup message modal
                  openModal({
                    type:
                      cancelTransactionRouteTarget ===
                      appRoutes.account.pathname
                        ? modalIds.userBookingCustomErrorModal
                        : 'payment-error'
                  })
                  //clear receipt error immediately, otherwise cause dead loop!!!
                  dispatch(clearReceipts())
                  // clear ticket for its obsolete
                  dispatch(clearTicketNumbers())
                }
              })
            }
          } else {
            setSubmittingForm(false)
            setSubmitFormError(true)
          }

          break
        case 'error':
          // an error occurred
          setSubmitFormError(true)
          setSubmittingForm(false)
          break
        case 'validation':
          // a field was validated
          break
        default:
          break
      }
    }
    element.addEventListener('mai-pay', handleMaiPayEvent)
    return () => element.removeEventListener('mai-pay', handleMaiPayEvent)
  }, [
    maiPayReady,
    activeModifyBooking,
    cancelTransactionRouteTarget,
    dispatch,
    duplicatePassengerQuantities,
    fields,
    handleRouteChange,
    openModal,
    passengerFieldDetails,
    paymentFerryId,
    summaryRouteCheck.routeIsValid,
    travelAgentBookingParams,
    userSelections.bookingInformation,
    userSelections.passengerDetails,
    bookingConfirmationData.customerNumber,
    currencyType,
    isTelephoneBooking,
    bookingConfirmationData.address,
    telephonePassengerFieldDetails,
    bookingConfirmationData
  ])

  // wait 40s for payment form render, if not go back to summary page
  useEffect(() => {
    let elapsed = 0
    const maxWait = 40000
    const interval = 500
    const timer = setInterval(() => {
      const maiPayExist = document.querySelector('mai-pay')
      const element = maiPayRef.current

      if (
        (maiPayExist && element && typeof element.submit === 'function') ||
        isInvoicePayment
      ) {
        clearInterval(timer)
        return
      }
      elapsed += interval
      if (elapsed >= maxWait) {
        clearInterval(timer)
        setSubmitFormError(true)
        openModal({ type: 'cancel-transaction' })
        dispatch(clearTicketNumbers())
        handleRouteChange(cancelTransactionRouteTarget)
      }
    }, interval)
    return () => clearInterval(timer)
  }, [
    cancelTransactionRouteTarget,
    dispatch,
    handleRouteChange,
    openModal,
    isInvoicePayment
  ])

  useEffect(() => {
    if (
      document.querySelector(
        `script[src^="https://www.google.com/recaptcha/api.js"]`
      )
    ) {
      return
    }

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHA_SITE_KEY}&hl=${lang}`
    script.async = true
    script.defer = true
    document.head.appendChild(script)
    return () => {
      document.head.removeChild(script)
    }
  }, [lang])

  // check payment method, if its invoice booking, display message indicating payment not allowed
  if (isInvoicePayment) {
    return (
      <p className="u-page-view-container u-padding-top u-text-center u-error-color">
        {labels.invoicePaymentErrorMsg ||
          HARD_CODE_LABELS[lang].invoicePaymentErrorMsg}
      </p>
    )
  }

  // FIXME: page data error
  // if (!pageData) {
  //   return (
  //     <p className="u-page-view-container u-padding-top u-text-center u-error-color">
  //       {labels.pageDataInvalidErroMsg ||
  //         HARD_CODE_LABELS[lang].pageDataInvalidErroMsg}
  //     </p>
  //   )
  // }

  return (
    <div className="booking-confirmation">
      <div className="padded-container">
        {/* {preloadError && (
          <p className="u-text-center" style={{ color: 'red' }}>
            {labels.anErrorOccured}
          </p>
        )} */}

        {/* {showHPF && hpfUrl && (
          <div className="iframe-wrapper">
            <iframe
              ref={iframeRef}
              style={{ height: '645px', width: '100%', border: 'none' }}
              id="paymentIframe"
              src={hpfUrl}
              title="Chase Hosted Payment Form"
            />
          </div>
        )} */}
        <div className="booking-confirmation__form">
          <mai-pay language={lang} ref={maiPayRef}></mai-pay>
          {maiPayReady ? (
            <div className="booking-confirmation__button">
              <button
                type="submit"
                id="submit-payment"
                className="btn btn-primary wide-primary-btn"
                onClick={async () => {
                  setCaptchaError(false)
                  dispatch(clearCaptchaToken())
                  const element = maiPayRef.current
                  if (element && typeof element.submit === 'function') {
                    const recaptchaToken = await executeRecaptchaCheck()
                    if (recaptchaToken) {
                      dispatch(getCaptchaToken(recaptchaToken))
                    }
                    element.submit()
                  } else {
                    setSubmitFormError(true)
                  }
                }}
              >
                {labels.payBtnMsg}
              </button>
              <button
                className="btn btn-primary secondary-btn"
                onClick={() => {
                  openModal({ type: 'cancel-transaction' })
                  dispatch(clearTicketNumbers())
                  handleRouteChange(cancelTransactionRouteTarget)
                }}
              >
                {labels.cancel}
              </button>
            </div>
          ) : (
            <BrandLoader />
          )}
          {submittingForm && (
            <div className="booking-confirmation__spinner">
              <BrandLoader />
            </div>
          )}
          {(submitFormError || captchaError) && (
            <div className="booking-confirmation__error">
              {labels.genericApiErrorMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

ChaseCheckoutContainer.propTypes = {
  bookingConfirmationData: shape().isRequired,
  ferryId: string.isRequired,
  labels: shape().isRequired,
  lang: string.isRequired,
  handleRouteChange: func.isRequired,
  openModal: func.isRequired,
  modalIsOpen: shape().isRequired,
  cancelTransactionRouteTarget: string
}

export default ChaseCheckoutContainer
